import { Cog } from "@procore/core-icons";
import { useCallback, useEffect } from "react";

import { EventOrigin, Events, track } from "apis/procore";
import { ToolbarButtonEntry, toolbarsActions, useDispatchToolbars } from "contexts/toolbars";
import { CORE_WINDOW_IDS, useDispatchWindows, useWindow, windowsActions } from "contexts/windows";

import { Toolbar } from "../Toolbar";

interface SettingsToolbarProps {
    id?: string;
}

/**
 * Settings toolbar with cog icon
 */
export function SettingsToolbar({ id = "settings-toolbar" }: SettingsToolbarProps) {
    const settingsWindow = useWindow(CORE_WINDOW_IDS.SETTINGS);
    const toolbarDispatch = useDispatchToolbars();
    const dispatchWindows = useDispatchWindows();

    const handleSettingsClick = useCallback(() => {
        dispatchWindows(windowsActions.toggleWindow(CORE_WINDOW_IDS.SETTINGS));
        void track(Events.toolbar.settingsTapped, { origin: EventOrigin.Toolbar });
    }, [dispatchWindows]);

    useEffect(() => {
        const buttons: ToolbarButtonEntry[] = [
            {
                config: {
                    id: "settings",
                    icon: <Cog />,
                    onClick: handleSettingsClick,
                    title: "Settings",
                },
                state: {
                    active: false,
                    disabled: false,
                    visible: true,
                },
            },
        ];
        toolbarDispatch(
            toolbarsActions.addToolbar({
                id,
                buttons,
            }),
        );

        return () => {
            toolbarDispatch(toolbarsActions.removeToolbar(id));
        };
    }, [toolbarDispatch, id, handleSettingsClick]);

    useEffect(() => {
        toolbarDispatch(
            toolbarsActions.updateButtonState(id, "settings", {
                active: settingsWindow?.state.open ?? false,
            }),
        );
    }, [toolbarDispatch, id, settingsWindow?.state.open]);

    return <Toolbar id={id} />;
}
